import { useState } from "react";
import api, { fmtErr } from "../api";
import { toast } from "sonner";
import { Sparkle } from "@phosphor-icons/react";
import { PhotoPicker } from "./PhotoPicker";

const CATEGORIES = [["tree_limb", "Tree / limb"], ["drainage", "Drainage"], ["pest", "Pest"], ["structural", "Structural"], ["access_safety", "Access / safety"], ["turf_health", "Turf health"], ["other", "Other"]];
const URGENCIES = [["routine", "Routine"], ["soon", "Soon"], ["urgent", "Urgent"]];

export const LogIssue = ({ propertyId, visitId = null, onDone, testid = "log-issue" }) => {
  const [description, setDescription] = useState("");
  const [photos, setPhotos] = useState([]);
  const [category, setCategory] = useState("other");
  const [urgency, setUrgency] = useState("routine");
  const [busy, setBusy] = useState(false);

  const aiAssist = async () => {
    if (!description.trim()) return toast.error("Write a rough note first");
    setBusy(true);
    try {
      const r = await api.post("/observations/ai-draft", { note: description });
      setDescription(r.data.description);
      setCategory(r.data.category);
      toast.success("Draft cleaned up — review and edit before saving");
    } catch (e) { toast.error(fmtErr(e)); }
    setBusy(false);
  };

  const submit = async () => {
    if (!description.trim()) return toast.error("Describe the issue");
    setBusy(true);
    try {
      await api.post("/observations", { property_id: propertyId, visit_id: visitId, description, photos, category, urgency });
      toast.success("Issue logged");
      onDone?.();
    } catch (e) { toast.error(fmtErr(e)); }
    setBusy(false);
  };

  return (
    <div className="space-y-3" data-testid={`${testid}-form`}>
      <textarea data-testid={`${testid}-description`} className="field-input h-24 w-full py-3" value={description}
        onChange={(e) => setDescription(e.target.value)}
        placeholder="What did you see? e.g. dead limb hanging over the driveway, water pooling by the garage…" />
      <button type="button" data-testid={`${testid}-ai`} onClick={aiAssist} disabled={busy}
        className="flex h-10 items-center gap-2 rounded-md border border-border px-4 text-xs font-bold text-muted-foreground disabled:opacity-40">
        <Sparkle size={14} weight="bold" /> Clean up with AI (suggested draft — you can edit)
      </button>
      <PhotoPicker photos={photos} setPhotos={setPhotos} min={0} testid={`${testid}-photo`} />
      <div>
        <p className="label-caps mb-2">Category</p>
        <div className="flex flex-wrap gap-2">
          {CATEGORIES.map(([k, label]) => (
            <button key={k} type="button" data-testid={`${testid}-cat-${k}`} onClick={() => setCategory(k)}
              className={`h-10 rounded-md border px-3 text-xs font-bold transition-colors ${category === k ? "border-primary bg-primary text-primary-foreground" : "border-border"}`}>{label}</button>
          ))}
        </div>
      </div>
      <div>
        <p className="label-caps mb-2">Urgency</p>
        <div className="flex gap-2">
          {URGENCIES.map(([k, label]) => (
            <button key={k} type="button" data-testid={`${testid}-urgency-${k}`} onClick={() => setUrgency(k)}
              className={`h-10 flex-1 rounded-md border text-xs font-bold transition-colors ${urgency === k ? "border-primary bg-primary text-primary-foreground" : "border-border"}`}>{label}</button>
          ))}
        </div>
      </div>
      <button type="button" data-testid={`${testid}-submit`} onClick={submit} disabled={busy} className="btn-primary-big !h-14 !text-base disabled:opacity-40">
        {busy ? "Saving…" : "Log issue"}
      </button>
    </div>
  );
};
